import { render, staticRenderFns } from "./Variety.vue?vue&type=template&id=42030024"
import script from "./Variety.vue?vue&type=script&lang=js"
export * from "./Variety.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports